import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import stats from 'assets/icons/hydration/stats.svg';
import { Container, Row, Col } from 'reactstrap';
import Layout from 'Layout/Layout';
import { PATH_HYDRATION_HISTORY } from '../paths';
import ProgressPlaceholder from './Progress/HydrationDayProgressPreloader';
import GoalPlaceholder from './Goal/HydrationDayGoalPlaceholder';
import AddPlaceholder from './Add/HydrationAddPlaceholder';

class HydrationDayContainerPlaceholder extends Component {
    render() {
        return (
            <Layout page="hydration">
                <Container>
                    <Row>
                        <Col
                            xs={12}
                            md={{ size: 8, offset: 2 }}
                            lg={{ size: 6, offset: 3 }}
                        >
                            <Link
                                to={PATH_HYDRATION_HISTORY}
                                className="btn-history"
                            >
                                <img src={stats} className="img-fluid" alt="" />
                            </Link>

                            <ProgressPlaceholder />
                            <GoalPlaceholder />
                            <AddPlaceholder />
                        </Col>
                    </Row>
                </Container>
            </Layout>
        );
    }
}

export default HydrationDayContainerPlaceholder;
